"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuList = void 0;
var _menuModule = _interopRequireDefault(require("@albelli/arc-3/lib/menu.module.css"));
var _react = _interopRequireDefault(require("react"));
var _MenuContext = require("./MenuContext");
var _MenuItem = require("./MenuItem");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const MenuList = _ref => {
  let {
    items,
    id,
    style
  } = _ref;
  const menuContext = (0, _MenuContext.useMenuContext)();
  const listId = id === "account-menu" ? _menuModule.default["account-menu"] : id;
  if (!!items && items.length) return /*#__PURE__*/_react.default.createElement("ul", {
    className: "".concat(_menuModule.default["arc3-menu__dropdown-content"], " arc3-typo-ul-no-style"),
    id: listId,
    style: style,
    "data-cy": "HeaderDropDowns"
  }, items.filter(i => menuContext.isAuthenticated || !menuContext.isAuthenticated && !i.isLogout).map((i, j) => /*#__PURE__*/_react.default.createElement(_MenuItem.MenuItem, _extends({
    key: i.text,
    secondary: true
  }, i))));
  return null;
};
exports.MenuList = MenuList;